import { useEffect, useState } from "react";
import FormGroup from "../components/FormGroup";
import InputText, { InputNumberFormat } from "../components/InputText";
import { Navigator, useStepper } from "../Stepper";
import Heading from "components/Heading";
import FormError from "components/FormError";
import apiRequest from "utils/apiRequest";
import styled, { css } from "styled-components";
import { colors } from "styles";
import parseDataBeforeSending from "utils/parseDataBeforeSending";
import * as Sentry from "@sentry/react";
import BubbleChat from "components/BubbleChat";
import * as ABTesting from "utils/ABTesting";
import Button from "components/Button";
import { flushSync } from "react-dom";

const SmallTxt = styled.p`
  text-align: center;
  font-size: 0.9em;
  color: ${colors.darkGray};
`;

const Transition = styled.div`
  transition: all 500ms ease-in-out;
  transform: translateX(100px);
  opacity: 0;

  ${(props) =>
    props.slideIn &&
    css`
      transform: translateX(0px);
      opacity: 1;
    `}

  ${(props) =>
    props.slideOut &&
    css`
      transform: translateX(-100px);
      opacity: 0;
    `}
`;

const PersonalInfo = () => {
  const { getDefault, setData, next } = useStepper();
  const [screen, setScreen] = useState("fullName");
  const [fullName, setFullName] = useState(
    [
      getDefault("personalInfo")?.firstName,
      getDefault("personalInfo")?.lastName,
    ]
      .filter(Boolean)
      .join(" ")
  );
  const [email, setEmail] = useState(getDefault("personalInfo")?.email || "");
  const [phoneNumber, setPhoneNumber] = useState(
    getDefault("personalInfo")?.phoneNumber || ""
  );
  const [canUseEmail, setCanUseEmail] = useState(true);
  const [validatingEmail, setValidatingEmail] = useState(false);
  const [error, setError] = useState(null);

  const [slideIn, setSlideIn] = useState(true);
  const [slideOut, setSlideOut] = useState(false);

  return (
    <>
      <Heading
        title={
          <>
            Reciba{" "}
            <strong
              style={{
                color: colors.blue,
              }}
            >
              GRATIS
            </strong>{" "}
            las recomendaciones para que pueda reparar su crédito y aumentar su
            score
          </>
        }
      />

      <form
        onSubmit={async (e) => {
          e.preventDefault();

          switch (screen) {
            case "fullName": {
              if (!!fullName && fullName.length >= 3) {
                const fullNameWords = fullName
                  .trim()
                  .split(" ")
                  .filter(Boolean);
                const lastName = fullNameWords.pop();
                const firstName = fullNameWords.join(" ");
                const data = {
                  firstName: firstName || lastName,
                  lastName: lastName || firstName,
                };

                setData("personalInfo", data, true);
              } else {
                setError("Nombre completo es requerido.");
                return;
              }

              break;
            }
            case "phoneNumber": {
              if (!!phoneNumber && phoneNumber.length >= 10) {
                setData(
                  "personalInfo",
                  {
                    phoneNumber,
                  },
                  true
                );
              } else {
                setError("Número de Teléfono es requerido.");
                return;
              }
              break;
            }
            case "email": {
              if (!email) {
                setError("Email es requerido.");
              } else if (canUseEmail && !validatingEmail) {
                const personalInfo = {
                  ...getDefault("personalInfo"),
                  email,
                };
                const data = {
                  ...personalInfo,
                  fixReasons: getDefault("reason"),
                  currentCreditScore: getDefault("currentScore"),
                  problemsAffectingScore:
                    getDefault("currentProblems")?.join(","),
                };
                const parsedData = parseDataBeforeSending(data);

                apiRequest("POST", "/captureFutureLead", parsedData).catch(
                  (error) => {
                    Sentry.captureMessage(`Cannot Capture Future Lead`, {
                      extra: {
                        error,
                        errorMsg: error?.message || "N/A",
                        data,
                        parsedData,
                      },
                      level: Sentry.Severity.Error,
                    });
                  }
                );

                return next(personalInfo);
              }

              return;
            }
            default: {
              break;
            }
          }

          setSlideOut(true);

          setTimeout(() => {
            flushSync(() => {
              setSlideIn(false);
              setSlideOut(false);
              setError(null);

              switch (screen) {
                case "fullName": {
                  setScreen("phoneNumber");
                  break;
                }
                case "phoneNumber": {
                  setScreen("email");
                  break;
                }
                default: {
                  setScreen("fullName");
                  break;
                }
              }
            });

            setTimeout(() => {
              setSlideIn(true);
            });
          }, 550);

          // const values = submitDataFn({
          //   fullName: e.target.elements.fullName.value,
          //   email: e.target.elements.email.value,
          //   // phoneNumber: e.target.elements.phoneNumber.value,
          //   phoneNumber,
          // });

          // next(values);
        }}
        style={{
          width: "100%",
          overflow: "hidden",
        }}
      >
        {screen === "fullName" && (
          <Transition slideOut={slideOut} slideIn={slideIn}>
            <InputText
              name="fullName"
              placeholder="Nombre Completo *"
              value={fullName}
              onChange={(e) => {
                setFullName(e.target.value);
              }}
              subtext="Campo obligatorio"
              error={error}
            />
          </Transition>
        )}

        {screen === "phoneNumber" && (
          <Transition slideOut={slideOut} slideIn={slideIn}>
            <InputNumberFormat
              name="phoneNumber"
              placeholder="Telefono *"
              type="tel"
              format="+1 (###) ### ####"
              mask="_"
              value={phoneNumber}
              onValueChange={({ value }) => {
                console.log("--value", value, value.length);
                setPhoneNumber(value);
              }}
              pattern="\++([0-9])+\s+(\([0-9]{3}\))+\s+([0-9]{3})+\s+([0-9]{4})"
              subtext="Campo obligatorio"
              error={error}
            />
          </Transition>
        )}

        {screen === "email" && (
          <Transition slideOut={slideOut} slideIn={slideIn}>
            <InputText
              name="email"
              placeholder="Email *"
              type="email"
              value={email}
              onChange={(e) => {
                setCanUseEmail(true);
                setEmail(e.target.value);
              }}
              onBlur={(e) => {
                if (e.target.validity.valid) {
                  setValidatingEmail(true);

                  apiRequest("POST", "/checkEmail", { email })
                    .then((response) => {
                      setCanUseEmail(!(response && response.exists));
                      setValidatingEmail(false);
                    })
                    .catch((_err) => {
                      setValidatingEmail(false);
                    });
                }
              }}
              subtext="Campo obligatorio"
              error={error}
            />
            {!canUseEmail && (
              <FormError>
                El email <strong>{email}</strong> ya esta en uso.
              </FormError>
            )}
          </Transition>
        )}

        <div
          style={{
            paddingTop: 25,
          }}
        >
          <Button $fluid type="submit">
            Continuar
          </Button>
        </div>

        {screen === "email" && (
          <SmallTxt>
            Al continuar, un especialista podrá comunicarse con usted para
            ayudarlo.
          </SmallTxt>
        )}
      </form>

      {ABTesting.getExperiment() === 1 && <BubbleChat />}
    </>
  );
};

export default PersonalInfo;
